import PropTypes from 'prop-types';
import React from 'react';

import { MeasurementDisplayTypes, Symbols } from '@powdr/constants';
import { useSensor } from '@powdr/hooks';

import { CircularGraph } from './circular-graph';
import { TextMeasurement } from './text-measurement';

export const Temperature = ({
  parentColorProfile = null,
  measurementLabel = null,
  measurementDisplayType = null,
  measurement = null,
  icon = null,
  sensor = null,
  sensorLocation = null,
}) => {
  const measurementData = useSensor(sensor, sensorLocation);

  if (!measurementData) return null;

  return (
    <>
      {(measurementDisplayType === MeasurementDisplayTypes.CIRCULAR_GRAPH) && (
        <CircularGraph
          colorProfile={parentColorProfile}
          label={measurementLabel}
        >
          {`${(measurementData?.temperature !== undefined) ? Math.round(measurementData.temperature) : Symbols.DOUBLE_DASH}${Symbols.DEGREE}`}
        </CircularGraph>
      )}
      {(measurementDisplayType === MeasurementDisplayTypes.TEXT
        || measurementDisplayType === MeasurementDisplayTypes.TEXT_LARGE) && (
        <TextMeasurement
          measurementDisplayType={measurementDisplayType}
          label={measurementLabel}
          icon={icon}
          measurement={measurement}
          colorProfile={parentColorProfile}
        >
          {`${(measurementData?.temperature !== undefined) ? Math.round(measurementData.temperature) : Symbols.DOUBLE_DASH}${Symbols.DEGREE}`}
        </TextMeasurement>
      )}
    </>
  );
};

Temperature.propTypes = {
  parentColorProfile: PropTypes.string,
  measurementLabel: PropTypes.string,
  measurementDisplayType: PropTypes.string,
  measurement: PropTypes.string,
  icon: PropTypes.string,
  sensor: PropTypes.shape({
    value: PropTypes.string,
    uuid: PropTypes.string,
  }),
  sensorLocation: PropTypes.string,
};
